// extracted by mini-css-extract-plugin
export default {"containerMobile":"searcherContainer-module__containerMobile__ZuR0K"};